export default "__VITE_ASSET__CuuBuqtg__"